import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import { ErrorBoundary } from './shell/ErrorBoundary.js';
import { ThemeProvider } from '../../shared/design-system/index.js';
import '../../shared/tokens/colors.css';
import '../../shared/tokens/typography.css';
import '../../shared/tokens/motion.css';
import '../../shared/tokens/base.css';
// Component primitives (.tl-btn, .tl-toolbar, …) must not depend on whether a
// route happens to import <Button>; loaded here they exist on every screen.
import '../../shared/components/primitives.css';
// Last, so the screen look wins over the base layer it builds on.
import '../../shared/tokens/screen-theme.css';
import '../../shared/tokens/brand-operations.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
);
